export const currentLang = () => document.documentElement.lang || 'et';
